<template>
  <div class="login-page">
    <!-- 登录表单 -->
    <div v-if="!isLoggedIn" class="login-container">
      <a-card title="用户登录" class="login-box">
        <a-space direction="vertical" style="width: 100%">
          <a-input v-model:value="username" placeholder="用户名" />
          <a-input-password v-model:value="password" placeholder="密码" />
          <a-button type="primary" block @click="handleLogin">登录</a-button>
        </a-space>
      </a-card>
    </div>

    <!-- 登录成功后显示命令测试页面 -->
    <proto-command-test v-if="isLoggedIn" />
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useRouter } from "vue-router";
import { onMounted, onUnmounted } from "vue";
import { TelegramClient } from "@/websocket/Client";
const client = TelegramClient.getInstance();
const router = useRouter();

onMounted(() => {
  client.connect();
});

// onUnmounted(() => {
// 	client.disconnect();
// });

const username = ref(""); // 将 account 改为 username
const password = ref("");
const isLoggedIn = ref(false);

const handleLogin = async () => {
  console.log("开始登录...");
  try {
    const result = await client.login(username.value, password.value);
    console.log("登录结果:", result);
    if (result.success && result.data) {
      localStorage.setItem("isLoggedIn", "true");
      localStorage.setItem("username", username.value);
      localStorage.setItem("session", result.data.session); // 保存session
      isLoggedIn.value = true;
      router.push("/chat");
    }
  } catch (error) {
    console.error("登录失败:", error);
  }
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f5f5;
}

.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-box {
  width: 400px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

h2 {
  text-align: center;
  margin-bottom: 24px;
  color: #333;
}

.input-group {
  margin-bottom: 16px;
}

input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s;
}

input:focus {
  border-color: #1890ff;
}

.login-btn {
  width: 100%;
  padding: 12px;
  background: #1890ff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
}

.login-btn:hover {
  background: #40a9ff;
}

.login-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}
</style>
